import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useSubscriptions } from "@/Common/context/subscriptions/Subscriptions";
import { onApproveAllWashouts } from "@/Washouts/api/PayrollClosing/subscriptions";
import { onRetractAllWashouts } from "@/Washouts/api/WashoutReview/subscriptions";
import { GraphqlSubscriptionResponse } from "@/Common/api/types/GraphqlSubscriptionResponse";
import { IOnApproveAllWashouts, IOnRetractAllWashouts } from "@/Washouts/types/PayrollClosing/subscriptionCallbacks";
import { onApproveAllWashoutsCallback, onRetractAllWashoutsCallback } from "@/Washouts/helpers/PayrollClosing/subscriptionCallbacks";

const useApproveAllWashoutSubscription = ({
	locationId,
	payPeriodId,
}: {
	commissionCycleId?: string;
	locationId: string;
	payPeriodId: string;
}) => {
	const { addSubscription, getSubscription } = useSubscriptions();
	const queryClient = useQueryClient();

	const commissionCycleSubscription = getSubscription(["approveAllWashoutsSubscription", payPeriodId]);
	commissionCycleSubscription?.subscriptions?.onApproveAllWashouts?.setCallback(
		(response: GraphqlSubscriptionResponse<"onApproveAllWashouts", IOnApproveAllWashouts>) => {
			onApproveAllWashoutsCallback({ queryClient, response });
		}
	);

	commissionCycleSubscription?.subscriptions?.onRetractAllWashouts?.setCallback(
		(response: GraphqlSubscriptionResponse<"onRetractAllWashouts", IOnRetractAllWashouts>) => {
			onRetractAllWashoutsCallback({ queryClient, response });
		}
	);

	useEffect(() => {
		addSubscription(
			["approveAllWashoutsSubscription", payPeriodId],
			[
				{
					context: "onApproveAllWashouts",
					query: onApproveAllWashouts,
					variables: {
						locationId,
						payPeriodId,
					},
				},
			]
		);

		addSubscription(
			["retractAllWashoutsSubscription", payPeriodId],
			[
				{
					context: "onRetractAllWashouts",
					query: onRetractAllWashouts,
					variables: {
						locationId,
						payPeriodId,
					},
				},
			]
		);

		return () => {};
	}, [locationId, payPeriodId]);
};

export default useApproveAllWashoutSubscription;
